import React, { useState, useEffect } from "react";
import "./subClient.css";
import {
  Breadcrumb,
  notification,
  Button,
  Table,
  Input,
  Image,
  Modal,
} from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import moment from "moment/moment";
import { GreenNotify, RedNotify } from "../../helper/helper";

import SubClient from "../../components/addSubClient/addSubClient";

import { homeIcon } from "../../assets";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const UserList = () => {
  const [subClients, setSubClient] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddCategoryModalVisible, setIsAddCategoryModalVisible] =
    useState(false);
  const getAllUser = async () => {
    let getRes = (res) => {
      console.log("hhhhhhhhhhhhhhhhhhh",res)
      setSubClient(res?.data?.users);
    };

    await callApi(
      "GET",
      `${routes.getUsers}?role=SubClient`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error,,", error);
      }
    );
  };

  useEffect(() => {
    getAllUser();
  }, []);
  const handleDelete = (recordId) => {
    callApi(
      "DELETE",
      `${routes.deleteClient}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          setSubClient((prevSub) =>
            prevSub.filter((sub) => sub._id !== recordId)
          );

          GreenNotify("Sub Client Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting Generes");
        }
      },
      (error) => {
        console.log("error", error);

        notification.error({
          message: "Error",
          description: "An error occurred while deleting the Generes.",
        });
      }
    );
  };
  const blocked = async (index, event, userId, blockStatus) => {
    event.stopPropagation();

    const data = {
      isBlocked: blockStatus,
    };

    try {
      let getRes = (res) => {
        if (res.status === 200) {
          setSubClient((prevSubClients) =>
            prevSubClients.map((user, i) =>
              i === index ? { ...user, isBlocked: blockStatus } : user
            )
          );
          GreenNotify(
            blockStatus
              ? "User Blocked Successfully"
              : "User Unblocked Successfully"
          );
        } else {
          RedNotify("Failed to update user block status.");
        }
      };
      callApi(
        "PATCH",
        `${routes.blockUser}/${userId}`,
        data,
        setIsLoading,
        getRes,
        (error) => {
          console.log("error", error);
        }
      );
    } catch (error) {
      console.error("Error blocking/unblocking user:", error);
      RedNotify("An error occurred while updating user block status.");
    }
  };
  const handleAddClient = () => {
    setUpdateRecordData(null);
    setIsAddCategoryModalVisible(true);
  };

  const makeFree = async (record) => {
    const selectedCategory = subClients.find(
      (subClient) => subClient._id === record
    );
    setUpdateRecordData(selectedCategory);
    setIsAddCategoryModalVisible(true);
  };

  const columns = [
    {
      title: "Client Name",
      dataIndex: "cname",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Client Email",
      dataIndex: "cemail",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Name",
      dataIndex: "name",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Number",
      dataIndex: "number",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Address",
      dataIndex: "address",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Registration Date",
      dataIndex: "createdAt",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Role",
      dataIndex: "role",
      className: "type-name-column-header",
      align: "center",
    },

    {
      title: "Block User",
      dataIndex: "blockORUnblock",
      align: "center",
      className: "action-column-header",
      render: (text, record, index) => (
        <div className="server-roles-trash-btn">
          {record.isBlocked ? (
            <Button
              style={{
                width: "80px",
                color: "white",
                backgroundColor: "#52c41a",
              }}
              onClick={(event) => blocked(index, event, record._id, false)}
            >
              Unblock
            </Button>
          ) : (
            <Button
              style={{
                width: "80px",
                color: "white",
                backgroundColor: "#f5222d",
              }}
              onClick={(event) => blocked(index, event, record._id, true)}
            >
              Block
            </Button>
          )}
        </div>
      ),
    },

    {
      title: "Action",
      dataIndex: "_id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => makeFree(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          ></Button>
        </div>
      ),
      width: "auto",
    },
  ];

  const data = subClients
    ?.map((item, index) => {
      return {
        key: index,
        _id: item?._id,
        name: item?.name,
        email: item?.email,
        number: item?.number,
        address: item?.address,
        cname: item?.parentId?.name,
        cemail: item?.parentId?.email,
        role: item?.role,
        createdAt: moment(item?.createdAt).format("MM-DD-YYYY"),

        isBlocked: item?.isBlocked,
      };
    })
    .filter((item) => {
      const usernameMatch = item.name
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const emailMatch = item.email
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      return usernameMatch || emailMatch;
    });

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };

  const handleViewDetails = async (record) => {
    let getRes = (res) => {
      setSelectedUser(res?.user);
      setModalVisible(true);
    };

    const result = await callApi(
      "GET",
      `${routes.getUserData}/${record._id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };
  const handleCloseModal = () => {
    setSelectedUser(null);
    setModalVisible(false);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Sub Clients</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Sub Clients</h1>
        <div></div>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search Name or Email"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAddClient}
        style={{ marginBottom: "16px" }}
      >
        Add Sub Client
      </Button>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        ></Table>
      </div>
      <Modal
        title={
          <span
            className={
              modalVisible
                ? "blink-animation user-details-label"
                : "user-details-label"
            }
          >
            User Details 👇
          </span>
        }
        visible={modalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        {selectedUser && (
          <div style={{ padding: "20px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  marginRight: "20px",
                  fontWeight: "bold",
                  fontSize: "30px",
                  animation: "fadeIn 1s ease",
                }}
              >
                {`${selectedUser?.fullName}`}
              </div>
              <div style={{ marginLeft: "150px" }}>
                <Image
                  style={{
                    borderRadius: "50%",
                    width: "140px",
                    height: "140px",
                  }}
                  src={selectedUser?.image}
                  alt="profile-image"
                />
              </div>
            </div>
          </div>
        )}
      </Modal>

      <SubClient
        visible={isAddCategoryModalVisible}
        toggleModal={() => {
          setIsAddCategoryModalVisible(false);
          getAllUser();
        }}
        recordData={updateRecordData}
      />
    </div>
  );
};

export default UserList;
